export default __webpack_public_path__ + "static/media/gallery-wip-greeblies_13.09dbd308.jpg";